import { Component, Input } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { AccessViewBaseComponent, slideDownAnimation } from '../access-view-base/access-view-base.component'

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'azure-access-view',
  templateUrl: './azure-access-view.component.html',
  styleUrls: ['./azure-access-view.component.scss'],
  standalone: false,
  animations: [slideDownAnimation],
})
export class AzureAccessViewComponent extends AccessViewBaseComponent {
  @Input() installCommand: string
  @Input() subscriptionId: string

  constructor(uiService: UiService) {
    super(uiService)
  }
}
